var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#f5f6fa","height":"100%","display":"flex","flex-direction":"column"}},[_c('hear'),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"fl justify-content align-items"},[_c('Notice'),_vm._v(" "),_c('Guarantee')],1)]),_vm._v(" "),_c('binad')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-298cfefd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/index/index.vue
// module id = null
// module chunks = 